export default __webpack_public_path__ + "static/media/refer_1.310d4073.png";